<template>
    <div class="loading-popup">
        <div class="app-popup-header">
            <h3>{{ title }}</h3>
        </div>
        <div class="app-popup-content">
            <loading-screen-svg />
        </div>
    </div>
</template>

<script>
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

export default {
    name: 'loading-popup',

    components: {
        'loading-screen-svg': LoadingScreenSvg,
    },

    props: {
        title: {
            type: String,
            default: 'loading...'
        },
    },
}
</script>

<style>
.loading-popup .app-popup-header {
    text-align: center;
    padding: 20px 30px;
    position: relative;
}

.loading-popup .app-popup-header::after {
    position: absolute;
    content: '';
    width: 10vw;
}

.loading-popup .app-popup-header h3 {
    margin-bottom: 0;
    display: inline-block;
    max-width: 90%;
    line-height: 1.5em;
    font-size: 30px;
}

#modals-container .v--modal-box {
    overflow: initial;
}

.loading-popup .app-popup-content  {
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
}

</style>
